module.exports = __webpack_public_path__ + "static/team-colin-whelan.9de08d2e.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/static/img/team-colin-whelan.jpg
// module id = 315
// module chunks = 0 1